var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7697b1e786cffe12642d6f5ec4dbc2ccecd9c477"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["commerce@muelheimmodular"]={id:"7697b1e786cffe12642d6f5ec4dbc2ccecd9c477"};
      